/**
 * FilterSection Component
 * 수수료 관리 검색 필터 섹션
 */
import React from 'react';
import { STATUS_FILTER_OPTIONS } from "../lib/supplierFeeHelpers";
import '@/shared/styles/search-form.css';

interface FilterSectionProps {
    filters: {
        riderName: string;
        riderId: string;
        statusFilter: string;
    };
    statusFilter: string;
    onFilterChange: (filters: { riderName: string; riderId: string; statusFilter: string }) => void;
    onSearch: () => void;
    onQuickFilter: (status: string) => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
    filters,
    statusFilter,
    onFilterChange,
    onSearch,
    onQuickFilter
}) => {
    return (
        <div className="card search-card">
            <div className="card-body">
                {/* 빠른 필터 버튼 */}
                <div className="quick-filter-row">
                    <div className="quick-filter-buttons">
                        {STATUS_FILTER_OPTIONS.map(option => (
                            <button
                                key={option.value}
                                type="button"
                                className={`quick-filter-btn ${statusFilter === option.value ? 'active' : ''}`}
                                onClick={() => onQuickFilter(option.value)}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="search-form rider-fee-search-form">
                    {/* 라이더명 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-user" />
                                라이더명
                            </label>
                            <input
                                type="text"
                                className="text-input"
                                value={filters.riderName}
                                onChange={(e) => onFilterChange({ ...filters, riderName: e.target.value })}
                                onKeyPress={(e) => e.key === 'Enter' && onSearch()}
                                placeholder="라이더명 입력..."
                            />
                        </div>
                    </div>

                    {/* 라이더ID */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-id-card" />
                                라이더ID
                            </label>
                            <input
                                type="text"
                                className="text-input"
                                value={filters.riderId}
                                onChange={(e) => onFilterChange({ ...filters, riderId: e.target.value })}
                                onKeyPress={(e) => e.key === 'Enter' && onSearch()}
                                placeholder="라이더ID 입력..."
                            />
                        </div>
                    </div>

                    {/* 버튼 그룹 */}
                    <div className="form-group button-group">
                        <button className="btn btn-primary" onClick={onSearch}>
                            <i className="fas fa-search" />
                            조회
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterSection;
